<template>
	<div class="vx-col" v-if="showPopup">
		<vs-popup
			:title="'Création Prestation'"
			:active.sync="isPopupActive"
			style="z-index: 54000"
		>
			<div class="vx-row mt-4">
				<div class="vx-col w-full">
					<vs-select
						autocomplete
						v-model="product.category"
						class="w-full select-large mt-4"
						placeholder="Catégorie"
						disabled
					>
						<vs-select-item
							:key="index"
							:value="item.value"
							:text="item.text"
							v-for="(item, index) in categoryOptions"
							class="w-full"
						/>
					</vs-select>
				</div>
			</div>
			<div class="vx-row mt-4" style="white-space: nowrap">
				<div class="vx-col inlineB">
					<vs-input
						v-model="product.perform"
						placeholder="Prestation"
						class="w-full"
						:style="styleValidator('perform')"
						id="select-control-width"
					/>
					<vx-tooltip
						v-if="validators['perform'].errText !== ''"
						:text="errText('perform')"
						class="ml-3"
						style="display: inline-block"
					>
						<vs-icon icon="error" size="medium" style="color: red"></vs-icon>
					</vx-tooltip>
				</div>
			</div>
			<div class="vx-row mt-4" style="white-space: nowrap">
				<div class="vx-col inlineB mb-2">
					<label for="" class="vs-select--label">Description courte</label>
					<vs-textarea
						v-model="product.shortDescription"
						class="mb-0"
						rows="1"
						:style="styleValidator('shortDescription')"
					/>
					<vx-tooltip
						v-if="validators['shortDescription'].errText !== ''"
						:text="errText('shortDescription')"
						class="ml-3"
						style="display: inline-block"
					>
						<vs-icon icon="error" size="medium" style="color: red"></vs-icon>
					</vx-tooltip>
				</div>
			</div>
			<div class="vx-row mt-2" style="white-space: nowrap">
				<div class="vx-col inlineB mb-2">
					<label for="" class="vs-select--label">Description longue</label>
					<vs-textarea
						v-model="product.longDescription"
						class="mb-0"
						rows="7"
						:style="styleValidator('longDescription')"
					/>
					<vx-tooltip
						v-if="validators['longDescription'].errText !== ''"
						:text="errText('longDescription')"
						class="ml-3"
						style="display: inline-block"
					>
						<vs-icon icon="error" size="medium" style="color: red"></vs-icon>
					</vx-tooltip>
				</div>
			</div>
			<div class="vx-row mt-2">
				<div class="vx-col w-full">
					<vs-checkbox class="inline-flex mt-4" v-model="product.isNetlink"
						>Est un produit de type Netlink</vs-checkbox
					>
				</div>
			</div>
			<div class="vx-row mt-3 right_element">
				<div class="vx-col">
					<vs-button class="mb-2" @click="createNewProduct">Ajouter</vs-button>
				</div>
			</div>
		</vs-popup>
		<div v-if="isLoading">Loading</div>
		<div v-else>
			<div v-if="finMissionPopup">
				<h3>Veuillez vérifier les tâches de cette prestation:</h3>
				<ValidateTaskTable
					:tasks="task"
					:apiUrl="apiUrl"
					:contractId="contract.id"
				/>
				<div class="vx-row">
					<div class="vx-col sm:w-1/2">
						<vs-button color="danger" class="mt-2 w-full" @click="decline()"
							>Annuler</vs-button
						>
					</div>
					<div class="vx-col sm:w-1/2">
						<vs-button color="primary" class="mt-2 w-full" @click="accept()"
							>Confirmer</vs-button
						>
					</div>
				</div>
			</div>
			<div v-else>
				<div class="vx-row">
					<div class="vx-col sm:w-1/2 w-full mb-2">
						<h3>Prestation commercialisée</h3>
					</div>
					<div class="vx-col sm:w-1/2 w-full mb-2">
						<vs-button
							class="float-right"
							radius
							color="primary"
							type="filled"
							icon-pack="feather"
							icon="icon-x"
							@click="closeForm"
						></vs-button>
					</div>
				</div>
				<!-- <div class="vx-row" v-if="$acl.check('admin')">
			  <div class="vx-col">
				  <vs-button
					  class="float-left"
					  color="primary"
					  type="filled"
					  @click="createNewProductPopup"
				  >
					  Prestation inexistante ?
				  </vs-button>
		  </div>
		  </div> -->
				<!--  -->
				<!-- STATUT -->
				<div class="flex gap-5">
					<div
						v-if="
							editMode &&
							(forceEdit ||
								($acl.check('admin') &&
									![4, 7, 8, 9].includes($props.missionToModify.status)) ||
								$acl.check('sadmin'))
						"
						class="vx-col w-1/5 mb-2"
					>
						<label for="" class="vs-select--label">Status</label>
						<vs-select
							autocomplete
							v-model="mission.status"
							class="w-full select-medium mr-2"
							:style="styleValidator('status')"
							@change="validateOne(mission.status, 'status')"
						>
							<vs-select-item
								:key="index"
								:value="item.value"
								:text="item.text"
								v-for="(item, index) in statusOptions"
								class="w-full"
							/>
						</vs-select>
					</div>
					<div v-else-if="editMode" class="vx-col w-1/5 mb-2 flex">
						<vs-chip
							style="width: 80px; height: 35px; align-self: self-end"
							:color="getContractStatusColor($props.missionToModify.status)"
							>{{ getContractStatus($props.missionToModify.status) }}
						</vs-chip>
					</div>
					<div v-else class="vx-col w-1/5 mb-2 flex"></div>
					<!-- Status -->
					<div
						v-if="mission.status == 3"
						class="vx-col w-1/5 mb-2"
						style="white-space: nowrap; align-items: end"
					>
						<!-- DATE -->
						<label for="" class="vs-select--label" style="color: red"
							>Pause Date de début *</label
						>
						<div class="w-full">
							<flat-pickr
								class="w-full"
								v-model="pauseStartDate"
								@input="validateDateDebut(pauseStartDate)"
								:config="configDatePicker"
							/>
							<vx-tooltip
								v-if="
									validators['missionStartDate'] &&
									validators['missionStartDate'].errText !== ''
								"
								:text="errText('missionStartDate')"
								class="ml-3"
								style="display: inline-block"
							>
								<vs-icon
									icon="error"
									size="medium"
									style="color: red"
								></vs-icon>
							</vx-tooltip>
						</div>
						<!-- /DATE -->
					</div>
					<div
						v-if="mission.status == 3"
						class="vx-col w-1/5 mb-2"
						style="white-space: nowrap; align-items: end"
					>
						<!-- DATE -->
						<label for="" class="vs-select--label" style="color: red"
							>Pause Date de fin
						</label>
						<div class="w-full">
							<flat-pickr
								class="w-full"
								v-model="pauseEndDate"
								@input="validateDateDebut(pauseEndDate)"
								:config="configDatePicker"
							/>
							<vx-tooltip
								v-if="
									validators['missionStartDate'] &&
									validators['missionStartDate'].errText !== ''
								"
								:text="errText('missionStartDate')"
								class="ml-3"
								style="display: inline-block"
							>
								<vs-icon
									icon="error"
									size="medium"
									style="color: red"
								></vs-icon>
							</vx-tooltip>
						</div>
						<!-- /DATE -->
					</div>
				</div>
				<div class="vx-row" style="white-space: nowrap; align-items: end">
					<div class="vx-col sm:w-1/5 mb-2">
						<div>
							<label for="" class="vs-select--label">Devise *</label>
							<div class="flex">
								<vs-select
									:name="Math.random()"
									v-model="selectedCurrency"
									:style="styleValidator('products_id')"
									class="w-full select-large"
									:disabled="disablePrestation"
									autocomplete
									id="select-control-width"
								>
									<vs-select-item
										:key="index"
										:value="item.sub_name"
										:text="item.name"
										v-for="(item, index) in currencies"
										class="w-full"
									/>
								</vs-select>
							</div>
						</div>

						<div v-if="!selectedCurrency" class="mt-auto">
							<i>Choisissez la devise pour continuer </i>
						</div>
					</div>
					<div
						class="vx-col sm:w-2/5 mb-2"
						v-if="selectedCurrency"
						style="align-items: end"
					>
						<div class="mt-4">
							<label for="" class="vs-select--label">Prestation *</label>
							<div class="flex w-full">
								<!-- :disabled="disablePrestation" -->
								<vs-select
									:name="Math.random()"
									v-model="mission.products_id"
									:style="styleValidator('products_id')"
									class="w-full select-large"
									:disabled="disablePrestation"
									@change="validateOne(mission.products_id, 'products_id')"
									autocomplete
									id="select-control-width"
								>
									<vs-select-item
										:key="index"
										:value="item.id"
										:text="
											([7, 8].includes(item.category)
												? missionCategories[item.category - 1] +
												  ' - ' +
												  item.perform
												: productOptions[0].category_name ==
												  missionCategories[item.category - 1]
												? missionCategories[item.category - 1] +
												  ' - ' +
												  item.perform
												: 'Autre - ' + item.perform) +
											' - ' +
											item.currency
										"
										v-for="(item, index) in currentProductByCurrency.filter(
											(p) => p.missionable == 1
										)"
										class="w-full"
									/>
								</vs-select>
								<vx-tooltip
									v-if="
										validators['products_id'] &&
										validators['products_id'].errText !== ''
									"
									:text="errText('products_id')"
									class="ml-3"
									style="display: inline-block"
								>
									<vs-icon
										icon="error"
										size="medium"
										style="color: red"
									></vs-icon>
								</vx-tooltip>
							</div>
						</div>
					</div>
					<div class="vx-col sm:w-2/5 w-full mb-2 mt-4" v-if="selectedCurrency">
						<label for="" class="vs-select--label">Commentaire</label>
						<vs-input class="w-full" v-model="mission.comment_mission" />
					</div>
				</div>
				<div v-if="selectedCurrency">
					<vs-divider position="center" class="m-3"> PRIX </vs-divider>
					<div class="vx-row" style="white-space: nowrap; align-items: end">
						<!-- Price -->
						<div
							class="vx-col sm:w-2/5 w-full mb-2 mt-4"
							style="white-space: nowrap; align-items: end"
						>
							<label for="" class="vs-select--label">
								Prix de vente HT (€)</label
							>
							<div class="container">
								<div class="flex-container">
									<vx-input-group>
										<template slot="prepend">
											<div class="prepend-text bg-primary">
												<span class="flex"
													><vs-icon icon="euro" size="small"></vs-icon
												></span>
											</div>
										</template>
										<div style="display: flex">
											<vs-input
												class="w-full"
												v-model="mission.price"
												:style="styleValidator('price')"
											/>

											<vx-tooltip
												v-if="
													validators['price'] &&
													validators['price'].errText !== ''
												"
												:text="errText('price')"
												class="ml-3"
												style="display: inline-block"
											>
												<vs-icon
													icon="error"
													size="medium"
													style="color: red"
												></vs-icon>
											</vx-tooltip>
											<vx-tooltip
												v-if="
													validators['price'] &&
													validators['price'].errText !== ''
												"
												:text="errText('price')"
												class="ml-3"
												style="display: inline-block"
											>
												<vs-icon
													icon="error"
													size="medium"
													style="color: red"
												></vs-icon>
											</vx-tooltip>
										</div>
									</vx-input-group>
									&nbsp;
									<div class="bottom-align">et/ou</div>
									&nbsp;
									<vx-input-group>
										<template slot="prepend">
											<div class="prepend-text bg-primary">
												<span class="flex"
													><vs-icon icon="percent" size="small"></vs-icon
												></span>
											</div>
										</template>
										<div style="display: flex">
											<vs-input
												class="w-full"
												v-model="mission.sold_percentage"
												:style="styleValidator('price')"
											/>

											<vx-tooltip
												v-if="
													validators['price'] &&
													validators['price'].errText !== ''
												"
												:text="errText('price')"
												class="ml-3"
												style="display: inline-block"
											>
												<vs-icon
													icon="error"
													size="medium"
													style="color: red"
												></vs-icon>
											</vx-tooltip>
											<vx-tooltip
												v-if="
													validators['price'] &&
													validators['price'].errText !== ''
												"
												:text="errText('price')"
												class="ml-3"
												style="display: inline-block"
											>
												<vs-icon
													icon="error"
													size="medium"
													style="color: red"
												></vs-icon>
											</vx-tooltip>
										</div>
									</vx-input-group>
								</div>
							</div>
						</div>
						<!-- PA=PV Checkbox -->
						<div
							class="vx-col sm:w-1/5 w-full mb-2 mt-4"
							style="
								align-items: flex-start;
								display: flex;
								flex-direction: column;
								justify-content: center;
							"
							oj
						>
							<label for="" class="vs-select--label">PA=PV (sans marge)</label>
							<vs-checkbox v-model="mission.is_no_marge" class="ml-3">
							</vs-checkbox>
						</div>
						<!-- Budegt Media Max -->
						<div
							class="vx-col w-1/5 mb-2"
							style="white-space: nowrap; align-items: end"
						>
							<!-- MAX BUDGET -->
							<label for="" class="vs-select--label"
								>Budget Média / Netlinking (P.V)</label
							>
							<div style="display: flex">
								<vs-input
									class="w-full"
									v-model="mission.max_budget"
									:style="styleValidator('max_budget')"
									@change="validateOne(mission.max_budget, 'max_budget')"
								/>
								<vx-tooltip
									v-if="
										validators['max_budget'] &&
										validators['max_budget'].errText !== ''
									"
									:text="errText('max_budget')"
									class="ml-3"
									style="display: inline-block"
								>
									<vs-icon
										icon="error"
										size="medium"
										style="color: red"
									></vs-icon>
								</vx-tooltip>
							</div>
							<!-- /MAX BUDGET -->
						</div>
						<!-- Comment Facturation -->
						<div
							class="vx-col sm:w-2/5 w-full mb-2 mt-4"
							v-if="selectedCurrency"
						>
							<label for="" class="vs-select--label"
								>Commentaire Facturation</label
							>
							<vs-input class="w-full" v-model="mission.commentary" />
						</div>
					</div>
					<vs-divider position="center" class="m-3"> CLIENT </vs-divider>
					<div class="vx-row mt-5">
						<div
							class="vx-col w-1/5 mb-2"
							style="white-space: nowrap; align-items: end"
						>
							<!-- TIME LIMIT -->
							<label for="" class="vs-select--label"
								>Temps maxi Consultant (heures)</label
							>
							<div style="display: flex">
								<vs-input
									class="w-full"
									v-model.number="mission.time_limit"
									:style="styleValidator('time_limit')"
									@change="validateOne(mission.time_limit, 'time_limit')"
								/>
								<vx-tooltip
									v-if="
										validators['time_limit'] &&
										validators['time_limit'].errText !== ''
									"
									:text="errText('time_limit')"
									class="ml-3"
									style="display: inline-block"
								>
									<vs-icon
										icon="error"
										size="medium"
										style="color: red"
									></vs-icon>
								</vx-tooltip>
							</div>
							<!-- /TIME LIMIT -->
						</div>
						<div
							class="vx-col w-1/5 mb-2"
							style="white-space: nowrap; align-items: end"
						>
							<!-- PROVIDER PRICE TEXT -->
							<label for="" class="vs-select--label"
								>Tarif Collaborateur Externe</label
							>
							<div style="display: flex">
								<vs-input
									class="w-full"
									v-model="mission.provider_price_text"
									:style="styleValidator('provider_price_text')"
									@change="
										validateOne(
											mission.provider_price_text,
											'provider_price_text'
										)
									"
								/>
								<vx-tooltip
									v-if="
										validators['provider_price_text'] &&
										validators['provider_price_text'].errText !== ''
									"
									:text="errText('provider_price_text')"
									class="ml-3"
									style="display: inline-block"
								>
									<vs-icon
										icon="error"
										size="medium"
										style="color: red"
									></vs-icon>
								</vx-tooltip>
							</div>
							<!-- /PROVIDER PRICE TEXT -->
						</div>
						<div
							class="vx-col w-1/5 mb-2"
							style="white-space: nowrap; align-items: end"
						>
							<!-- NUMBER OF MEETING -->
							<label for="" class="vs-select--label"
								>Nb. Points avec le client</label
							>
							<div style="display: flex">
								<vs-input
									class="w-full"
									v-model.number="mission.meeting_number"
									:style="styleValidator('meeting_number')"
									@change="
										validateOne(mission.meeting_number, 'meeting_number')
									"
								/>
								<vx-tooltip
									v-if="
										validators['meeting_number'] &&
										validators['meeting_number'].errText !== ''
									"
									:text="errText('meeting_number')"
									class="ml-3"
									style="display: inline-block"
								>
									<vs-icon
										icon="error"
										size="medium"
										style="color: red"
									></vs-icon>
								</vx-tooltip>
							</div>
							<!-- /NUMBER OF MEETING -->
						</div>

						<!-- /STATUT -->
					</div>

					<div class="vx-row w-full mt-4" v-if="isContent">
						<vs-divider position="center" class="m-3"> CONTENT </vs-divider>
						<!-- /THEMA -->
						<div
							class="vx-col w-1/5 mb-2"
							style="white-space: nowrap; align-items: end"
						>
							<label for="" class="vs-select--label">Thematique *</label>
							<div style="display: flex">
								<vs-input
									class="w-full"
									v-model="mission.category"
									:style="styleValidator('content_category')"
									@change="validateOne(mission.category, 'content_category')"
								/>
								<vx-tooltip
									v-if="
										validators['meeting_number'] &&
										validators['meeting_number'].errText !== ''
									"
									:text="errText('meeting_number')"
									class="ml-3"
									style="display: inline-block"
								>
									<vs-icon
										icon="error"
										size="medium"
										style="color: red"
									></vs-icon>
								</vx-tooltip>
							</div>
						</div>
						<!-- /THEMA -->
						<!-- /Nb mots -->
						<div
							class="vx-col w-1/5 mb-2"
							style="white-space: nowrap; align-items: end"
						>
							<label for="" class="vs-select--label">Nb. Page</label>
							<div style="display: flex">
								<vs-input
									class="w-full"
									v-model="mission.num_pages"
									type="number"
									:style="styleValidator('num_pages')"
									@change="validateOne(mission.num_pages, 'num_pages')"
								/>
								<vx-tooltip
									v-if="
										validators['meeting_number'] &&
										validators['meeting_number'].errText !== ''
									"
									:text="errText('meeting_number')"
									class="ml-3"
									style="display: inline-block"
								>
									<vs-icon
										icon="error"
										size="medium"
										style="color: red"
									></vs-icon>
								</vx-tooltip>
							</div>
						</div>
						<!-- /Nb mots -->
						<!-- /Nb mots -->
						<div
							class="vx-col w-1/5 mb-2"
							style="white-space: nowrap; align-items: end"
						>
							<label for="" class="vs-select--label">Nb. Mots</label>
							<div style="display: flex">
								<vs-input
									class="w-full"
									v-model="mission.num_words"
									type="number"
									:style="styleValidator('num_words')"
									@change="validateOne(mission.num_words, 'num_words')"
								/>
								<vx-tooltip
									v-if="
										validators['meeting_number'] &&
										validators['meeting_number'].errText !== ''
									"
									:text="errText('meeting_number')"
									class="ml-3"
									style="display: inline-block"
								>
									<vs-icon
										icon="error"
										size="medium"
										style="color: red"
									></vs-icon>
								</vx-tooltip>
							</div>
						</div>
						<!-- /Nb mots -->
						<!-- /Language -->
						<div class="vx-col sm:w-1/5 mb-2" style="align-items: end">
							<label for="" class="vs-select--label">Langue *</label>
							<div class="flex w-full">
								<vs-select
									:name="Math.random()"
									v-model="mission.language"
									:style="styleValidator('language')"
									class="w-full select-large"
									@change="validateOne(mission.language, 'language')"
									autocomplete
									defa
									id="select-control-width"
								>
									<vs-select-item
										:key="index"
										:value="item.id"
										:text="item.name"
										v-for="(item, index) in redacLang"
										class="w-full"
									/>
								</vs-select>
							</div>
						</div>
						<!-- /Language -->
						<!-- /Diffivult -->
						<div class="vx-col sm:w-1/5 mb-2" style="align-items: end">
							<label for="" class="vs-select--label">Complexité *</label>
							<div class="flex w-full">
								<vs-select
									:name="Math.random()"
									v-model="mission.difficulty"
									:style="styleValidator('language')"
									class="w-full select-large"
									@change="validateOne(mission.language, 'language')"
									autocomplete
									defa
									id="select-control-width"
								>
									<vs-select-item
										:key="index"
										:value="item.id"
										:text="item.name"
										v-for="(item, index) in levelList"
										class="w-full"
									/>
								</vs-select>
							</div>
						</div>
						<!-- /Diffivult -->
					</div>

					<div class="vx-row w-full mt-4">
						<vs-divider position="center" class="m-3"> DATE </vs-divider>
						<div
							class="vx-col w-1/5 mb-2"
							style="white-space: nowrap; align-items: end"
						>
							<!-- DATE -->
							<label for="" class="vs-select--label">Date de début</label>
							<div class="w-full">
								<flat-pickr
									class="w-full"
									v-model="missionStartDate"
									@input="validateDateDebut(missionStartDate)"
									:config="configDatePicker"
								/>
								<vx-tooltip
									v-if="
										validators['missionStartDate'] &&
										validators['missionStartDate'].errText !== ''
									"
									:text="errText('missionStartDate')"
									class="ml-3"
									style="display: inline-block"
								>
									<vs-icon
										icon="error"
										size="medium"
										style="color: red"
									></vs-icon>
								</vx-tooltip>
							</div>
							<!-- /DATE -->
						</div>

						<div class="vx-col w-1/5 mb-2">
							<label for="" class="vs-select--label"
								>Récurrence de la prestation</label
							>
							<vs-checkbox
								:disabled="isMissionFlexible ? true : false"
								v-model="mission.recurrence"
								>Récurrence
							</vs-checkbox>
						</div>

						<div class="vx-col w-1/5 mb-2" style="align-items: end">
							<div>
								<label
									for=""
									class="vs-select--label"
									v-show="mission.recurrence"
									>Fréquence de la récurrence</label
								>
								<vs-select
									autocomplete
									:style="styleValidator('frequency')"
									@change="validateOne(mission.frequency, 'frequency')"
									v-model="mission.frequency"
									v-show="mission.recurrence"
									class="w-full select-large"
								>
									<vs-select-item
										:key="index"
										:value="item.value"
										:text="item.text"
										v-for="(item, index) in frequencyOptions"
										class="w-full"
									/>
								</vs-select>
								<vx-tooltip
									v-if="
										validators['frequency'] &&
										validators['frequency'].errText !== '' &&
										this.mission.recurrence == true
									"
									:text="errText('frequency')"
									class="ml-3"
									style="display: inline-block"
								>
									<vs-icon
										icon="error"
										size="medium"
										style="color: red"
									></vs-icon>
								</vx-tooltip>
							</div>
						</div>

						<!-- <div class="vx-col w-1/5 mb-2" style="white-space: nowrap; align-items: end;" v-if="mission.recurrence == true && mission.frequency == 0">
		
			  <label for="" class="vs-select--label"
			  >Durée de la mission (mois)</label>
			  <div style="display: flex;">
				  <vs-input
					  class="w-full"
					  v-model.number="mission.mission_duration"
					  :style="styleValidator('mission_duration')"
					  @input="validateMissionDuration(mission.mission_duration)"
				  />
				  <vx-tooltip v-if="validators['mission_duration'] && validators['mission_duration'].errText !== ''" :text="errText('mission_duration')" class="ml-3" style="display: inline-block;">
					  <vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
				  </vx-tooltip>
			  </div>
			 
		  </div> -->

						<div
							v-if="mission.recurrence == true && mission.frequency == 0"
							class="vx-col w-1/5 mb-2"
							style="white-space: nowrap; align-items: end"
						>
							<!-- DATE -->
							<label for="" class="vs-select--label">Date de fin estimée</label>
							<div>
								<flat-pickr
									class="w-full"
									v-model="mission.estimated_end_date"
									:config="configDatePicker"
									:style="styleValidator('estimated_end_date')"
									@input="
										validateOne(
											mission.estimated_end_date,
											'estimated_end_date'
										)
									"
								/>
								<vx-tooltip
									v-if="
										validators['estimated_end_date'] &&
										validators['estimated_end_date'].errText !== ''
									"
									:text="errText('estimated_end_date')"
									class="ml-3"
									style="display: inline-block"
								>
									<vs-icon
										icon="error"
										size="medium"
										style="color: red"
									></vs-icon>
								</vx-tooltip>
							</div>
							<!-- /DATE -->
						</div>
					</div>
					<div class="vx-column w-1/3 t-border mt-4">
						<label for="" class="vs-select--label"
							>Sélectionnez un Consultant</label
						>
						<vx-input-group>
							<vs-select
								v-model="selectedAccountManager"
								class="w-full"
								placeholder="Consultant Rankwell"
								autocomplete
								:disabled="isMissionFlexible"
								@change="handleAccountManagerClick"
							>
								<vs-select-item
									:key="index"
									:value="item"
									:text="item.firstname + ' ' + item.lastname"
									v-for="(item, index) in accountmanagerOptions"
									class="w-full"
								/>
							</vs-select>
							<!-- <vs-button
									:disabled="isMissionFlexible"
									class="mt-2"
									@click="addAccountManager(selectedAccountManager)"
									>Ajouter</vs-button
								> -->
						</vx-input-group>
						<vs-table
							class="mt-3"
							style="overflow: hidden"
							:data="accountmanagerList"
							v-if="accountmanagerList"
							v-model="lead_account_manager"
							noDataText="Aucun Consultant sélectionné."
							:key="refreshList"
						>
							<template slot="thead">
								<vs-th>Consultant(e-s)</vs-th>
								<!-- Madame ou Monsieur -->
								<vs-th></vs-th>
							</template>

							<template slot-scope="{ data }">
								<vs-tr
									:data="data[indextr]"
									:key="indextr"
									v-for="(tr, indextr) in data"
								>
									<vs-td style="width: 10%">{{
										data[indextr].firstname + " " + data[indextr].lastname
									}}</vs-td>
									<!-- Madame ou Monsieur -->
									<!--<vs-td v-if="lead_account_manager == data[indextr]"><vs-button @click="deleteAccountManagerLead(data[indextr].id)" class="mx-2">Supprimer</vs-button><span>Lead</span></vs-td>-->
									<vs-td
										><vs-button
											:disabled="isMissionFlexible"
											@click="deleteAccountManager(data[indextr].id)"
											>Supprimer</vs-button
										></vs-td
									>
								</vs-tr>
							</template>
						</vs-table>
					</div>

					<div class="vx-row float-right mt-4">
						<div class="vx-col w-full">
							<vs-button color="danger" class="mb-2 mr-3" @click="closeForm()"
								>Annluer</vs-button
							>
							<vs-button
								v-if="!editMode"
								id="addButton"
								class="mb-2 vs-con-loading__container"
								ref="mission-save-button-1"
								@click="formSubmitted"
								>Ajouter</vs-button
							>
							<vs-button
								v-else
								class="mb-2 vs-con-loading__container"
								ref="mission-save-button-1"
								@click="formSubmitted"
								>Enregistrer</vs-button
							>
						</div>
					</div>
				</div>
			</div>

			<!-- <div class="vx-row mt-4">
				<vs-button v-if="isLoad"
					><i class="fa fa-circle-o-notch fa-spin"></i> Loading</vs-button
				>
				<vs-button v-else class="mb-2" @click="formSubmitted"
					>Enregistrer</vs-button
				>
			</div> -->
		</div>
	</div>
</template>
  
  <script>
import VueCookies from "vue-cookies";
import Mission from "@/entities/Mission";
import Product from "@/entities/Product";
import Validator from "@/entities/Validator";
import { ContractUser } from "@/entities/ContractUser";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";
import utilsMixin from "@/mixins/utilsMixin";
import VxTooltip from "./../../../components/widgets/vx-tooltip/VxTooltip.vue";
import ValidateTaskTable from "@/components/tables/ValidateTaskTable";
import store from "@/store/store";

export default {
	name: "MissionForContract",
	mixins: [dbFieldConvertor, utilsMixin],
	props: {
		contract: Object,
		missionToModify: Object,
		show: Boolean,
		apiUrl: String,
		router: Object,
		editMode: Boolean,
		editContract: {
			type: Boolean,
			default: false,
		},
	},
	components: {
		ValidateTaskTable,
		flatPickr,
		VxTooltip,
	},
	data() {
		return {
			isLoad: false,
			showPopup: this.$props.show,
			isLoading: false,
			// USER OBJECT
			isContent: false,
			langaugeList: [{ id: 1, name: "FRancaise" }],
			isMissionFlexible: false,
			mission: Mission.getFormFields(),
			missionOld: Mission.getFormFields(),
			contractUser: new ContractUser(),
			product: Product.getFormFields(),
			forceEdit: false,
			levelList: [
				{ id: 1, name: "Standard" },
				{ id: 2, name: "Medium" },
				{ id: 3, name: "Premium" },
			],
			deliveryId: this.$props.contract.delivery, // Doit être le même que le type du contrat
			// apiUrl: this.$store.state.backendApiUrl,
			missionStartDate: new Date()
				.toISOString()
				.substring(0, 10)
				.split("-")
				.reverse()
				.join("/"),
			pauseStartDate: this.$props.missionToModify
				? this.$props.missionToModify.pause_start_date
					? this.$props.missionToModify.pause_start_date
					: new Date()
							.toISOString()
							.substring(0, 10)
							.split("-")
							.reverse()
							.join("/")
				: new Date()
						.toISOString()
						.substring(0, 10)
						.split("-")
						.reverse()
						.join("/"),
			pauseEndDate: this.$props.missionToModify
				? this.$props.missionToModify.pause_end_date
					? this.$props.missionToModify.pause_end_date
					: null
				: null,
			// FORM SELECT OPTIONS
			disablePrestation: false,
			accountmanagerOptions: [],
			products: [],
			deliveryOptions: [
				{ text: "SEO", value: 1 },
				{ text: "SEA", value: 2 },
				{ text: "E-Réputation", value: 3 },
				{ text: "Social Ads", value: 4 },
				{ text: "Autre", value: 7 },
			],
			productOptions: [],
			currentProductByCurrency: [],
			categoryOptions: Product.getProductCategories(),
			frequencyOptions: [
				{ text: "Mensuelle", value: 0 },
				{ text: "Bimestrielle", value: 1 },
				{ text: "Trimestrielle", value: 2 },
				{ text: "Semestrielle", value: 3 },
				{ text: "Annuelle", value: 4 },
			],
			statusOptions: [],
			configDatePicker: {
				dateFormat: "d/n/Y",
			},
			isPopupActive: false,
			validators: {
				perform: {
					errText: "",
				},
				longDescription: {
					errText: "",
				},
				shortDescription: {
					errText: "",
				},
				price: {
					errText: "",
				},
				status: {
					valid: true,
					notValid: false,
					errText: "",
				},
			},
			fieldTypes: {
				password: "text",
			},
			selectedAccountManager: null,
			accountmanagerList: [],
			lead_account_manager: [],
			lead_account_manager_On: false,
			check: true,
			checkProduct: false,
			overEndDate: false,
			finMissionPopup: false,
			task: [],
			missionCategories: [],
			tmpPriceTxt: null,
			refreshList: 0,
			currencies: [],
			selectedCurrency: "EUR",
		};
	},
	computed: {
		activeUser: () => {
			return VueCookies.get("userInfo");
		},
		redacLang: () => {
			return store.state.redac_lang;
		},
	},
	beforeUnmount() {
		// Find and remove any lingering tooltip elements
		const tooltips = document.querySelectorAll(".vx-tooltip-content");
		tooltips.forEach((tooltip) => tooltip.remove());
	},
	updated() {
		console.log("updated");
	},
	async created() {
		try {
			this.isLoading = true;
			await this.fetchCurrencies();
			await this.getAllProducts();
			store.dispatch("getRedacLang");
			await this.getAllProductsCategories();
			await this.getAllAccountManager();
			await this.getAllProductForCategory();
			if (this.$props.editMode) {
				this.statusOptions = this.getStatusOptionContract(
					this.$props.missionToModify.status,
					this.$props.contract.status
						? this.$props.contract.status
						: this.$props.contract[0].status,
					this.$acl.check("sadmin")
				);
				this.selectedCurrency = this.$props.missionToModify.currency;
				this.isContent =
					this.$props.missionToModify.category == 8 ? true : false;

				// disable the prestation if the status is 1
				if ([8, 2].includes(Number(this.$props.missionToModify.status))) {
					this.disablePrestation = false;
				} else {
					this.disablePrestation = true;
				}
				this.getAccountManagerList();
			}

			//
			if (
				this.$props.missionToModify &&
				this.$props.missionToModify.status == 2
			)
				this.forceEdit = true;

			console.log("this.$props.missionToModify false");
			this.isLoading = false;
		} catch (e) {
			console.log("ERRRROR ", e);
			this.isLoading = false;
		}
		//   this.statusOptions = this.$props.editMode && this.$props.missionToModify.status == 9 ? this.statusOptions.filter(s => s.value == 4 || s.value == 9) : this.statusOptions;
		//   //console.log("STATUSSS", this.statusOptions);
	},
	mounted() {
		//get Mission Info for edit
		if (this.$props.editMode) {
			this.missionOld = JSON.parse(JSON.stringify(this.$props.missionToModify));
			this.mission = JSON.parse(JSON.stringify(this.$props.missionToModify));
			if (this.mission.meeting_number == 0) this.mission.meeting_number = null;
			this.missionStartDate = this.mission.start_date
				? this.mission.start_date
						.substring(0, 10)
						.split("-")
						.reverse()
						.join("/")
				: null;
			this.mission.estimated_end_date = this.mission.estimated_end_date
				? this.mission.estimated_end_date
						.substring(0, 10)
						.split("-")
						.reverse()
						.join("/")
				: null;
			this.selectedCurrency = this.$props.missionToModify.currency;
		}
	},
	watch: {
		"mission.products_id": function (val) {
			if (this.mission.status == 3) return;
			let choosedProduct = this.productOptions.find(
				(product) => product.id == val
			);
			// if the product is a content
			if (choosedProduct.category == 8) this.isContent = true;
			else this.isContent = false;
			
			// if the product category is 7 and max_budget is null, set it to 0
			if (choosedProduct.sub_category == 7 && this.mission.max_budget == null) {
				this.mission.max_budget = 0;
			}
		},
		// selectedAccountManager: function (data) {
		// 	if (data) {
		// 		this.addAccountManager(data);
		// 	}
		// },

		selectedCurrency: function (data) {
			this.chooseProductsByCurrency(data);
		},
		deliveryId: function () {
			this.getAllProductForCategory();
		},
		mission: function () {
			if (this.mission.price_text) this.mission.price = this.mission.price_text;
		},
	},
	methods: {
		handleAccountManagerClick() {
			if (this.selectedAccountManager) {
				if (this.selectedAccountManager.length > 1) {
					this.selectedAccountManager.shift();
				}
				this.addAccountManager(this.selectedAccountManager);
			}
		},
		chooseProductsByCurrency(currency) {
			let choosedCurrency = currency ? currency : this.selectedCurrency;
			this.currentProductByCurrency = this.productOptions.filter(
				(product) => product.currency == choosedCurrency
			);
			if (this.$props.editMode)
				this.mission.products_id = this.$props.missionToModify.products_id;
		},
		handleType(event) {
			const { srcElement, type } = event;
			const { name, value } = srcElement;

			if (type === "blur" && !value) {
				this.fieldTypes[name] = "text";
			} else {
				this.fieldTypes[name] = "password";
			}
		},
		//validating date debut and adjust estimated_end_date aaccoordinly
		validateDateDebut(missionDateDebut) {
			if (missionDateDebut != null && this.mission.mission_duration != null) {
				// only if it is not edit mode
				if (!this.$props.editMode)
					this.mission.estimated_end_date = this.calculateEstimatedEndDate(
						missionDateDebut,
						this.mission.mission_duration
					);
				this.validateOne(missionDateDebut, "missionStartDate");
			}
		},
		validateMissionDuration(missionDuration) {
			// only if it is not edit mode
			if (!this.$props.editMode)
				this.mission.estimated_end_date = this.calculateEstimatedEndDate(
					this.missionStartDate,
					missionDuration
				);
			this.validateOne(missionDuration, "mission_duration");
		},
		validateMissionStartingDate(missionStartingDate) {
			// this.mission.estimated_end_date = this.calculateEstimatedEndDate(missionStartingDate, this.mission.mission_duration);
			this.validateOne(missionStartingDate, "missionStartDate");
		},
		calculateEstimatedEndDate(startingDate, monthDuration) {
			let objStartingDate;
			// //console.log("startingDate", startingDate);
			if (!startingDate) return null;
			if (startingDate.split("/").length > 0)
				objStartingDate = new Date(
					startingDate.substring(0, 10).split("/").reverse().join("-")
				);
			else objStartingDate = new Date(startingDate.substring(0, 10));
			// //console.log("objStartingDate", objStartingDate);
			let yearToAdd = Math.floor(monthDuration / 12);
			let monthToAdd = monthDuration % 12;
			objStartingDate.setFullYear(objStartingDate.getFullYear() + yearToAdd);
			objStartingDate.setMonth(objStartingDate.getMonth() + monthToAdd);
			return objStartingDate
				.toISOString()
				.substring(0, 10)
				.split("-")
				.reverse()
				.join("/");
		},
		accept() {
			try {
				for (let account_manager of this.accountmanagerList) {
					account_manager.is_lead = 0;
					if (this.lead_account_manager.id == account_manager.id)
						account_manager.is_lead = 1;
				}
				this.mission.account_managers = this.accountmanagerList;
				this.createMission(this.$props.editMode)
					.then(async (res) => {
						let notificationText = this.$props.editMode
							? "Mission modifiée avec succès."
							: "Mission ajoutée avec succès.";
						this.mission = new Mission(this.mission);
						if (this.$props.editMode) {
							await this.mission.updateUserRelation(
								this.$props.contract.society_id,
								this.$props.contract.id,
								this.$props.missionToModify.id,
								this.missionOld.account_managers,
								this.activeUser.id
							);
							// this.modifyTask(this.mission.id);
						} else {
							await this.mission.updateUserRelation(
								this.$props.contract.society_id,
								this.$props.contract.id,
								res.data.id,
								this.missionOld.account_managers,
								this.activeUser.id
							);
							if (
								this.$props.contract.status &&
								this.$props.contract.status != 2
							) {
								if (this.mission.status == 1)
									await this.createTask(res.data.id);
							}
						}
						this.$vs.notify({
							title: "Succès",
							text: notificationText,
						});
						if (this.$props.editContract == true) {
							let foundMission = this.productOptions.find(
								(product) => product.id == this.mission.products_id
							);
							let missionName =
								this.missionCategories[foundMission.category - 1] +
								" - " +
								foundMission.perform;
							if (this.mission.status != 4 && this.$props.editMode == false)
								this.sendMissionMailNotification(
									this.$props.contract[0].id,
									missionName,
									this.$props.contract[0].society_id,
									this.activeUser.firstname + " " + this.activeUser.lastname
								);
						}
						this.$emit("close-form-after-added", 1);
						this.showPopup = false;
					})
					.catch((err) => {
						console.log("ERRORO in ", err);
						let notificationText = this.$props.editMode
							? "La mission n'a pas été modifiée."
							: "La mission n'a pas été ajoutée.";
						this.$vs.notify({
							title: "Echec",
							text: notificationText,
						});
					});
				this.finMissionPopup = false;
			} catch (e) {
				console.error(e);
			}
		},
		decline(param) {
			this.finMissionPopup = false;
		},
		getAccountManagerList() {
			this.$http
				.get(
					this.apiUrl + "mission/getuidlist/" + this.$props.missionToModify.id
				)
				.then((res) => {
					this.accountmanagerList = res.data;
					this.missionOld.account_managers = [...res.data];
				})
				.catch((error) => {
					//console.log(error);
				});
		},
		addAccountManager(selectedAccountManager) {
			if (selectedAccountManager) {
				let selectedAccountManagerIsPresent = this.accountmanagerList.filter(
					(accountManager) => accountManager.id == selectedAccountManager.id
				);
				if (selectedAccountManagerIsPresent.length <= 0) {
					this.lead_account_manager = selectedAccountManager;
					this.accountmanagerList = [];
					this.accountmanagerList.push(selectedAccountManager);
				}
			}
		},
		deleteAccountManager(selectedAccountManager) {
			this.accountmanagerList = this.accountmanagerList.filter(
				(accountManager) => accountManager.id != selectedAccountManager
			);
		},
		deleteAccountManagerLead(selectedAccountManager) {
			//console.log("deleteAccountManagerLead");
			this.accountmanagerList = this.accountmanagerList.filter(
				(accountManager) => accountManager.id != selectedAccountManager
			);
			if (this.accountmanagerList.length > 0)
				this.lead_account_manager = this.accountmanagerList[0];
			else this.lead_account_manager_On = false;
			this.refreshList++;
		},

		/**
		 * Query our API to fetch all product for a category
		 */
		async getAllProductForCategory() {
			if (!this.deliveryId) {
				this.deliveryId = "1";
			}
			//console.log(this.product);
			if (this.product) this.product.category = this.deliveryId - 1;
			let category_result = await this.getProductCategoryData(this.deliveryId);

			//removing budget flexible in modification
			if (this.$props.editMode) {
				this.productOptions = category_result.filter(
					(p) =>
						p.category == category_result[0].category ||
						p.category == 7 ||
						p.category == 8
				);
			} else {
				this.productOptions = category_result.filter(
					(p) =>
						p.category == category_result[0].category ||
						p.category == 7 ||
						p.category == 8
				);
			}
			this.chooseProductsByCurrency();
		},
		/**
		 * @method getProductCategoryData
		 * @param {Number} category_id
		 * @returns {Array}
		 */
		async getProductCategoryData(category_id) {
			return new Promise((resolve, reject) => {
				this.$http
					.get(this.$props.apiUrl + "product/all/" + category_id.toString())
					.then((res) => {
						//console.log(res);
						resolve(res.data);
						// if(res.data.length > 0) this.mission.products_id = res.data[0].id;
					})
					.catch((err) => {
						console.error(err);
						reject(err);
					});
			});
		},

		/**
		 * Query our API to fetch all account manager
		 */
		async getAllAccountManager() {
			return new Promise((resolve, reject) => {
				this.$http
					.get(this.apiUrl + "users/all/accountmanager")
					.then((res) => {
						//console.log("getAllAccountManager");
						this.accountmanagerOptions = res.data.filter(
							(collaborator) => collaborator.status == 1
						);
						resolve(this.accountmanagerOptions);
					})
					.catch((err) => {
						console.error(err);
						reject(err);
					});
			});
		},
		/**
		 * Query our API to fetch all product
		 */
		async getAllProducts() {
			return new Promise((resolve, reject) => {
				this.$http
					.get(this.apiUrl + "product/all")
					.then((res) => {
						//console.log("getAllProducts", res.data);
						//console.log("GETITING PRODECUT", res.data);
						this.products = res.data;
						resolve(this.products);
					})
					.catch((err) => {
						console.error(err);
						reject(err);
					});
			});
		},
		/**
		 * Query our API to fetch all product categories
		 */
		async getAllProductsCategories() {
			return new Promise((resolve, reject) => {
				this.$http
					.get(this.apiUrl + "product/category/all")
					.then((res) => {
						//console.log("getAllProductsCategories", res.data);
						this.missionCategories = res.data.map((row) => row.name);
						resolve(this.missionCategories);
					})
					.catch((err) => {
						console.error(err);
						reject(err);
					});
			});
		},

		getTask() {
			return new Promise((resolve, reject) => {
				try {
					this.$http
						.get(
							this.apiUrl +
								"task/getMissionTasks/" +
								this.$props.missionToModify.id
						)
						.then((res) => {
							let tasks = res.data;
							this.task = tasks;
							resolve(this.task);
						})
						.catch((err) => {
							console.error(err);
							reject(err);
						});
				} catch (e) {
					console.error(e);
					reject(e);
				}
			});
		},

		sendMissionMailNotification(
			contractId,
			missionName,
			societyId,
			userFullName
		) {
			let params = {
				contract: contractId,
				mission: missionName,
				societyId: societyId,
				userFullName: userFullName,
			};
			this.$http
				.post(this.apiUrl + "mail/newmission", params)
				.then(() => {
					//console.log("sendMissionMailNotification");
				})
				.catch((err) => {
					console.error(err);
				});
		},

		validateOne(val, name) {
			/*
			 * if(this.mission.frequency !== 0 || !this.mission.recurrence){
			 * 	this.mission.mission_duration = null;
			 * 	this.mission.estimated_end_date = null;
			 * }
			 */
			console.log("Running validateOne");
			// if (name == "products_id") {
			// 	let choosedProduct = this.productOptions.find(
			// 		(product) => product.id == val
			// 	);
			// 	// if the product is a content
			// 	console.log("choosedProduct", val, this.productOptions, choosedProduct);
			// 	if (choosedProduct.category == 8) this.isContent = true;
			// 	else this.isContent = false;
			// }

			// fotr flexible budget
			if (name == "products_id" && val == 136) {
				this.isMissionFlexible = true;
				this.mission.recurrence = 1;
				let leadCons = this.$props.contract.account_manager_avatars[0];
				let obj = {
					firstname: leadCons.name,
					id: leadCons.users_id,
					status: 1,
					lastname: "",
				};
				this.accountmanagerList = [obj];
			} else {
				this.isMissionFlexible = false;
			}

			if (this.mission.meeting_number == 0) this.mission.meeting_number = null;

			let value = val;
			value == 0 ? (value = "0") : "";
			let constname = "";

			switch (name) {
				case "products_id":
				case "time_limit":
				case "frequency":
				case "mission_duration":
				case "num_words":
				case "num_pages":
				case "meeting_number":
					constname = "isNumberConstraint";
					break;
				case "max_budget":
					constname = "priceConstraint";
					break;
				case "missionStartDate":
				case "estimated_end_date":
					constname = "dateConstraint";
					break;
			}

			/*
			 * Verifier la date saisie
			 *  if(this.mission.recurrence == true && this.mission.frequency == 0 && name == "estimated_end_date"){
			 *  	this.validators[name] = new Validator({constraintName: constname});
			 *  	if(value == 0){
			 *  		this.validators[name].errText = "Ce champ ne peut être vide.";
			 *  		this.validators[name].valid = false;
			 *  		this.$forceUpdate();
			 *  		return;
			 *  	}
			 *  	let startDate = "";
			 *  	let tmpEndDate = String(value).split("/");
			 *  	tmpEndDate[0].length < 2 ? tmpEndDate[0] = "0" + tmpEndDate[0] : " ";
			 *  	tmpEndDate[1].length < 2 ? tmpEndDate[1] = "0" + tmpEndDate[1] : " ";
			 *  	let days = tmpEndDate[0];
			 *  	let years = tmpEndDate[2];
			 *  	tmpEndDate[0] = years;
			 *  	tmpEndDate[2] = days;
			 *  	let endDate = tmpEndDate.join("");
			 *  	if(this.missionStartDate && this.missionStartDate !== ""){
			 *  		startDate = this.missionStartDate;
			 *  		let tmpStartDate = String(startDate).split("/");
			 *  		tmpStartDate[0].length < 2 ? tmpStartDate[0] = "0" + tmpStartDate[0] : " ";
			 *  		tmpStartDate[1].length < 2 ? tmpStartDate[1] = "0" + tmpStartDate[1] : " ";
			 *  		let daye = tmpStartDate[0];
			 *  		let yeare = tmpStartDate[2];
			 *  		tmpStartDate[0] = yeare;
			 *  		tmpStartDate[2] = daye;
			 *  		startDate = tmpStartDate.join("");
			 *  	}
			 *  	else{
			 *  		startDate = 0;
			 *  	}
			 *  	if(Number(endDate) - Number(startDate) <= 0){
			 *  		this.validators["missionStartDate"].errText = "";
			 *  		this.validators["missionStartDate"].valid = true;
			 *  		this.validators[name].valid = false;
			 *  		this.validators[name].errText = "La date de fin estimée ne peut pas être inférieure ou égale à la date de début.";
			 *  		this.$forceUpdate();
			 *  		return;
			 *  	}
			 *  	else{
			 *  		if(Number(endDate) - Number(startDate) == Number(endDate)){
			 *  			this.validators[name].errText = "";
			 *  			this.validators[name].valid = true;
			 *  			this.validators["missionStartDate"].errText = "Ce champ ne peut être vide.";
			 *  			this.validators["missionStartDate"].valid = false;
			 *  			this.$forceUpdate();
			 *  			return;
			 *  		}
			 *  		else{
			 *  			this.validators[name].errText = "";
			 *  			this.validators[name].valid = true;
			 *  			this.$forceUpdate();
			 *  			return;
			 *  		}
			 *  	}
			 *  }
			 *  else
			 */

			if (name == "missionStartDate") {
				this.validators[name] = new Validator({ constraintName: constname });
				if (value == 0) {
					this.validators[name].errText = "Ce champ ne peut être vide.";
					this.validators[name].valid = false;
					this.$forceUpdate();
					return;
				}
				this.validators["missionStartDate"].errText = "";
				this.validators["missionStartDate"].valid = true;

				/*
				 * if(this.mission.mission_duration > 0){
				 * 	// this.mission.estimated_end_date = this.calculateEstimatedEndDate(value, this.mission.mission_duration);
				 * }
				 */
			} else if (name == "mission_duration" && this.mission.recurrence) {
				/*
				 * if(this.missionStartDate == 0 || this.missionStartDate == null){
				 * 	if(!this.validators["missionStartDate"]){
				 * 		this.validators["missionStartDate"] = new Validator({constraintName: "dateConstraint"});
				 * 	}
				 * 	this.validators["missionStartDate"].errText = "Ce champ ne peut être vide.";
				 * 	this.validators["missionStartDate"].valid = false;
				 * 	this.$forceUpdate();
				 * 	return;
				 * }
				 */
				this.validators[name] = new Validator({ constraintName: constname });
				if (Number(value) > 0) {
					//console.log("Number(value) > 0");
					// this.mission.estimated_end_date = this.calculateEstimatedEndDate(this.missionStartDate, value);
					this.validators[name].errText = "";
					this.validators[name].valid = true;
					this.validators[name].notValid = false;
				} else if (Number(value) == 0) {
					this.validators[name].errText = "Ce champ ne peut être vide ou 0.";
					this.validators[name].valid = false;
				} else {
					this.validators[name].check(value);
				}
				this.$forceUpdate();
				return;
			}
			// else if (name == "num_words" && this.isContent) {
			// 	/*
			// 	 * if(this.missionStartDate == 0 || this.missionStartDate == null){
			// 	 * 	if(!this.validators["missionStartDate"]){
			// 	 * 		this.validators["missionStartDate"] = new Validator({constraintName: "dateConstraint"});
			// 	 * 	}
			// 	 * 	this.validators["missionStartDate"].errText = "Ce champ ne peut être vide.";
			// 	 * 	this.validators["missionStartDate"].valid = false;
			// 	 * 	this.$forceUpdate();
			// 	 * 	return;
			// 	 * }
			// 	 */
			// 	this.validators[name] = new Validator({ constraintName: constname });
			// 	if (Number(value) > 0) {
			// 		//console.log("Number(value) > 0");
			// 		// this.mission.estimated_end_date = this.calculateEstimatedEndDate(this.missionStartDate, value);
			// 		this.validators[name].errText = "";
			// 		this.validators[name].valid = true;
			// 		this.validators[name].notValid = false;
			// 	} else if (Number(value) == 0) {
			// 		this.validators[name].errText = "Ce champ ne peut être vide ou 0.";
			// 		this.validators[name].valid = false;
			// 	} else {
			// 		this.validators[name].check(value);
			// 	}
			// 	this.$forceUpdate();
			// 	return;
			// }
			else if (name === "status") {
				if ([1, 3].includes(value) && !this.missionStartDate) {
					if (this.validators[name]) {
						this.validators[name].valid = false;
						this.validators[name].notValid = true;
						this.validators[name].errText =
							"Vous devez entrer une date de début pour ce statut.";
						//console.log(name, this.validators[name]);
					}
				} else {
					if (this.validators[name]) {
						this.validators[name].valid = true;
						this.validators[name].notValid = false;
					}
				}
				if (
					this.$props.missionToModify.status == 9 &&
					value == 4 &&
					!this.$acl.check("sadmin")
				) {
					this.mission.status = 9;
					this.$vs.notify({
						title: "Echec",
						text: "Vous n'avez pas le droit de modifier ce statut",
					});
				}
				if (
					this.$props.missionToModify.status != 9 &&
					value == 9 &&
					!this.$acl.check("sadmin")
				) {
					this.mission.status == this.$props.missionToModify.status;
					this.$vs.notify({
						title: "Echec",
						text: "Vous n'avez pas le droit",
					});
				}
			} else if (
				name !== "frequency" ||
				name !== "mission_duration" ||
				name !== "missionStartDate" ||
				name !== "estimated_end_date"
			) {
				if (this.validators[name]) {
					this.validators[name].check(value);
					if (
						this.validators[name].valid == false &&
						this.validators[name].errText == ""
					) {
						name == "products_id"
							? (this.validators[name].errText = "Ce champ ne peut être vide.")
							: " ";
					}
					//name == "price" && this.mission.price == "" ? this.validators[name].errText = "Ce champ ne peut être vide." : "";
				}
			}

			if (this.validators[name])
				this.validators[name].valid == false &&
				this.validators[name].errText !== ""
					? (this.check = false)
					: "";

			this.$forceUpdate();
		},
		errText(name) {
			if (this.validators[name] && this.validators[name].errText !== "") {
				return this.validators[name].errText;
			}
		},
		styleValidator(name) {
			if (this.validators[name] && this.validators[name].errText !== "") {
				return "border: 1px solid red !important; border-radius: 5px;";
				/*
				 * if(["missionStartDate", "estimated_end_date", "products_id", "perform", "longDescription", "shortDescription", "price", "mission_duration"].includes(name)){
				 * 	return "border: 1px solid red !important; border-radius: 5px;";
				 * }
				 * else{
				 * 	return "border: 1px solid red !important; border-radius: 0 5px 5px 0;";
				 * }
				 */
			} else if (this.validators[name] && this.validators[name].errText == "") {
				return "border: 1px solid green !important; border-radius: 5px;";
				/*
				 * if(["missionStartDate", "estimated_end_date", "products_id", "perform", "longDescription", "shortDescription", "price", "mission_duration"].includes(name)){
				 * 	return "border: 1px solid green !important; border-radius: 5px;";
				 * }
				 * else{
				 * 	return "border: 1px solid green !important; border-radius: 0 5px 5px 0;";
				 * }
				 */
			}
		},
		formatDateToISO(dateString, includeTime = true, useT = false) {
			try {
				if (!dateString) return null;

				dateString = dateString.trim();

				// ISO regex including optional milliseconds and 'Z'
				const isoRegex =
					/^\d{4}-\d{2}-\d{2}(?:[T\s]\d{2}:\d{2}:\d{2}(?:\.\d+)?Z?)?$/i;

				if (isoRegex.test(dateString)) {
					const date = new Date(dateString);

					if (isNaN(date)) return null;

					const year = date.getFullYear();
					const month = String(date.getMonth() + 1).padStart(2, "0");
					const day = String(date.getDate()).padStart(2, "0");

					const isoDate = `${year}-${month}-${day}`;

					if (!includeTime) {
						return isoDate;
					}

					const hours = String(date.getHours()).padStart(2, "0");
					const minutes = String(date.getMinutes()).padStart(2, "0");
					const seconds = String(date.getSeconds()).padStart(2, "0");

					const timeSeparator = useT ? "T" : " ";
					return `${isoDate}${timeSeparator}${hours}:${minutes}:${seconds}`;
				}

				// Parse assumed dd/mm/yyyy format
				const dateParts = dateString.substring(0, 10).split("/");
				if (dateParts.length !== 3) return null;

				const day = dateParts[0].padStart(2, "0");
				const month = dateParts[1].padStart(2, "0");
				const year = dateParts[2];

				const isoDate = `${year}-${month}-${day}`;

				if (!includeTime) {
					return isoDate;
				}

				const timeSeparator = useT ? "T" : " ";
				return `${isoDate}${timeSeparator}02:00:00`;
			} catch (error) {
				console.error("Error formatting date:", error);
				return null;
			}
		},

		createMission(isEdit = false) {
			return new Promise((resolve, reject) => {
				try {
					let formatedStartDate = null;
					let formatedEndDate = null;
					let formatedpauseEndDate = null;
					let formatedpauseStartDate = null;
					if (this.missionStartDate) {
						formatedStartDate = this.missionStartDate.substring(0, 10);
						formatedStartDate = formatedStartDate
							.split("/")
							.reverse()
							.join("-");
						formatedStartDate = formatedStartDate + " 02:00:00";
					}
					if (this.pauseEndDate) {
						formatedpauseEndDate = this.formatDateToISO(
							this.pauseEndDate,
							true,
							false
						);
					}
					if (this.pauseStartDate) {
						formatedpauseStartDate = this.formatDateToISO(
							this.pauseStartDate,
							true,
							false
						);
					}
					/*
					 * if(!this.validators["mission_duration"] && !this.validators["estimated_end_date"] && !this.validators["missionStartDate"]){
					 * 	formatedEndDate = this.mission.estimated_end_date;
					 * }
					 * else{
					 */
					if (
						this.mission.recurrence == true &&
						this.mission.estimated_end_date
					) {
						formatedEndDate = this.mission.estimated_end_date.substring(0, 10);
						formatedEndDate = formatedEndDate.split("/").reverse().join("-");
						formatedEndDate = formatedEndDate + " 02:00:00";
						//console.log("formatedEndDate", formatedEndDate);
					}
					// }

					let baseStatus = 8;
					if (formatedStartDate) {
						let today = new Date(Date.now());
						let startDateObj = new Date(formatedStartDate);
						//console.log("Is mission active?", today, startDateObj, startDateObj <= today);
						baseStatus = startDateObj <= today ? 1 : baseStatus;
					}
					if (this.$props.contract.status && this.$props.contract.status == 2) {
						baseStatus = 2;
					} else if (
						!this.$props.contract.status &&
						this.$props.contract[0].status == 2
					) {
						baseStatus = 2;
					}
					let contract_id = null;
					let society_id = null;
					if (this.$props.contract instanceof Array) {
						contract_id = this.$props.contract[0].id;
						society_id = this.$props.contract[0].society_id;
					} else {
						society_id = this.$props.contract.society_id;
						contract_id = this.$props.contract.id;
					}
					let action = isEdit ? "mission/edit" : "mission/new";
					let params = isEdit
						? {
								id: this.mission.id,
								commentary: this.mission.commentary,
								comment_mission: this.mission.comment_mission,
								price: this.tmpPriceTxt ? null : this.mission.price,
								price_text: this.tmpPriceTxt ? this.tmpPriceTxt : null,
								recurrence: this.mission.recurrence,
								frequency: this.mission.frequency,
								time_limit: this.mission.time_limit,
								provider_price_text: this.mission.provider_price_text,
								start_date: formatedStartDate,
								estimated_end_date: formatedEndDate,
								mission_duration: this.mission.mission_duration
									? this.mission.mission_duration
									: null,
								end_date:
									this.mission.end_date !== null ? this.mission.end_date : null,
								status: [1, 8].includes(this.mission.status)
									? baseStatus
									: this.mission.status,
								products_id: this.mission.products_id,
								contract_id: contract_id,
								contract_society_id: society_id,
								meeting_number: this.mission.meeting_number,
								max_budget: this.mission.max_budget === "" ? null : this.mission.max_budget,
								flexible: this.mission.products_id == 136 ? true : false,
								user_id: this.activeUser.id,
								category: this.mission.category,
								pause_start_date: formatedpauseStartDate,
								pause_end_date: formatedpauseEndDate,
								sold_percentage: Number(this.mission.sold_percentage),
								is_no_marge: this.mission.is_no_marge,

								num_words: this.mission.num_words,
								num_pages: this.mission.num_pages,
								language: this.mission.language,
								difficulty: this.mission.difficulty,
						  }
						: {
								commentary: this.mission.commentary,
								comment_mission: this.mission.comment_mission,
								price: this.tmpPriceTxt ? null : this.mission.price,
								price_text: this.tmpPriceTxt ? this.tmpPriceTxt : null,
								recurrence: this.mission.recurrence,
								frequency: this.mission.frequency,
								time_limit: this.mission.time_limit,
								provider_price_text: this.mission.provider_price_text,
								startDate: formatedStartDate,
								estimated_end_date: formatedEndDate,
								mission_duration: this.mission.mission_duration
									? this.mission.mission_duration
									: null,
								end_date:
									this.mission.end_date !== null ? this.mission.end_date : null,
								status: baseStatus,
								flexible: this.mission.products_id == 136 ? true : false,
								products_id: this.mission.products_id,
								contract_id: [contract_id],
								contract_society_id: society_id,
								meeting_number: this.mission.meeting_number,
								max_budget: this.mission.max_budget === "" ? null : this.mission.max_budget,
								user_id: this.activeUser.id,
								category: this.mission.category,
								num_words: this.mission.num_words,
								num_pages: this.mission.num_pages,
								language: this.mission.language,
								difficulty: this.mission.difficulty,
								sold_percentage: Number(this.mission.sold_percentage),
								is_no_marge: this.mission.is_no_marge,
						  };

					this.$http
						.post(this.apiUrl + action, params)
						.then((res) => {
							store.dispatch("getAllFlexibleMissions");
							resolve(res);
						})
						.catch((err) => reject(err));
					// resolve(true)
				} catch (e) {
					reject(e);
				}
			});
		},

		/**
		 * Send the data to tha API to create the new user
		 * If the form is successfully sent, the user is redirect to Client.vue
		 */
		async formSubmitted() {
			try {
				this.check = true;
				let text = "Veuillez remplir tous les champs correctement.";
				//let fields = ["price", "products_id", "max_budget", "time_limit", "meeting_number", "frequency", "status"];
				let fields = [
					"price",
					"products_id",
					"missionStartDate",
					"mission_duration",
					"estimated_end_date",
					"max_budget",
					"time_limit",
					"meeting_number",
					"frequency",
					"status",
				];
				for (let i = 0; i < fields.length; i++) {
					let name = "";
					let value = "";

					if (fields[i] == "missionStartDate") {
						value = this.missionStartDate;
					} else {
						value = this.mission[fields[i]];
					}

					value == 0 ? (value = "0") : "";

					switch (fields[i]) {
						case "products_id":
						case "time_limit":
						case "meeting_number":
						case "mission_duration":
						case "frequency":
							value ? (value = String(value)) : "";
							value == null ? (value = "") : "";
							name = "isNumberConstraint";
							break;
						case "max_budget":
							value == null ? "" : (value = String(value));
							name = "priceConstraint";
							break;
					}

					if (fields[i] == "frequency") {
						if (this.mission.recurrence) {
							this.validators[fields[i]] = new Validator({
								constraintName: name,
							});
							this.validators[fields[i]].check(value);
							this.validators[fields[i]].valid == false &&
							this.validators[fields[i]].errText == ""
								? (this.validators[fields[i]].errText =
										"Ce champ ne peut être vide.")
								: "";
							this.validators[fields[i]].valid == false &&
							this.validators[fields[i]].errText !== ""
								? (this.check = false)
								: "";
						}
					} else if (fields[i] == "max_budget") {
						this.validators[fields[i]] = new Validator({
							constraintName: name,
						});
						this.validators[fields[i]].check(value);
						let foundProduct = this.products.findIndex(
							(row) => row.id == this.mission.products_id
						);
						// Netlinking budget validation removed - no longer required
						// if (foundProduct >= 0) {
						// 	if (this.products[foundProduct].sub_category == 7 && !value) {
						// 		this.validators[fields[i]].valid = false;
						// 		this.validators[fields[i]].errText =
						// 			"Ce champ ne peut être vide lorque la prestation est une prestation de netlinking.";
						// 		this.validators[fields[i]].notValid = true;
						// 		this.validators[fields[i]].validText = "";
						// 		this.check = false;
						// 	}
						// }
					} else if (fields[i] == "price") {
						if (this.mission.price) {
							this.mission.price = String(this.mission.price).trim();
							if (
								this.mission.price.match(
									/^[0-9\s]+(\.\s{0,}\d{1,1}\s{0,}\d{1,1}|\,\s{0,}\d{1,1}\s{0,}\d{1,1})?$/
								)
							) {
								this.mission.price.replace(/\s/g, "");
								this.mission.price.replace(",", ".");
								this.tmpPriceTxt = null;
							} else {
								this.tmpPriceTxt = this.mission.price;
							}
						} else {
							this.tmpPriceTxt = null;
						}
					} else if (fields[i] === "status") {
						if ([1, 3].includes(value) && !this.missionStartDate) {
							if (this.validators[fields[i]]) {
								//console.log("contrat status update ", value ,this.missionStartDate );
								if ([1].includes(value) && !this.missionStartDate) {
									this.validators[fields[i]].valid = true;
									this.validators[fields[i]].notValid = false;
								} else {
									this.validators[fields[i]].valid = false;
									this.validators[fields[i]].notValid = true;
									this.validators[fields[i]].errText =
										"Vous devez entrer une date de début pour ce statut.";
									this.check = false;
									text = "Vous devez entrer une date de début pour ce statut.";
								}
							}
						} else {
							if (this.validators[fields[i]]) {
								this.validators[fields[i]].valid = true;
								this.validators[fields[i]].notValid = false;
							}
						}
					} else if (
						fields[i] !== "mission_duration" ||
						fields[i] !== "missionStartDate" ||
						fields[i] !== "estimated_end_date"
					) {
						this.validators[fields[i]] = new Validator({
							constraintName: name,
						});
						this.validators[fields[i]].check(value);
						if (
							this.validators[fields[i]].valid == false &&
							this.validators[fields[i]].errText == ""
						) {
							if (fields[i] == "products_id")
								this.validators[fields[i]].errText =
									"Ce champ ne peut être vide.";
						}
						this.validators[fields[i]].valid == false &&
						this.validators[fields[i]].errText !== ""
							? (this.check = false)
							: "";
					}
				}

				if (this.check == false) {
					//this.$vs.loading.close('#addButton > vs-con-loading__container')

					console.log("this.check == false", text);
					this.$vs.notify({
						title: "Echec",
						text: text,
					});
					this.$forceUpdate();

					return false;
				} else {
					if (this.tmpPriceTxt) {
						this.mission.price_text = this.tmpPriceTxt;
						this.mission.price = null;
					} else if (!this.tmpPriceTxt && this.mission.price) {
						this.mission.price = Number(this.mission.price);
						this.mission.price_text = null;
					}

					let tasks = this.$props.missionToModify ? await this.getTask() : [];
					if (
						(this.mission.status == 4 &&
							tasks.filter((ele) => ele.archivate == 0).length > 0) ||
						(this.$props.missionToModify &&
							this.$props.missionToModify.status != this.mission.status &&
							this.mission.status == 1 &&
							this.mission.recurrence == 0)
					) {
						this.finMissionPopup = true;
					} else {
						let lead;

						if (
							this.contract.account_manager_avatars &&
							this.contract.account_manager_avatars.length > 0
						)
							lead = this.contract.account_manager_avatars[0].users_id;
						///ss
						if (
							lead &&
							this.accountmanagerList.length == 0 &&
							!this.$props.editMode
						)
							this.accountmanagerList = this.accountmanagerOptions.filter(
								(manager) => manager.id == lead
							);

						let contract_id = null;
						let society_id = null;
						if (this.$props.contract instanceof Array) {
							contract_id = this.$props.contract[0].id;
							society_id = this.$props.contract[0].society_id;
						} else {
							society_id = this.$props.contract.society_id;
							contract_id = this.$props.contract.id;
						}
						//console.log("this.$props.contract", this.$props.contract);
						if (!this.mission.contract_id || !this.mission.society_id) {
							this.mission.contract_id = contract_id;
							this.mission.contract_society_id = society_id;
						}

						//console.log("this.accountmanagerList", this.accountmanagerList);
						this.mission.account_managers = this.accountmanagerList;
						this.setLoading(true, "mission-save-button-1");
						this.createMission(this.$props.editMode)
							.then(async (res) => {
								let notificationText = this.$props.editMode
									? "Mission modifiée avec succès."
									: "Mission ajoutée avec succès.";
								this.mission = new Mission(this.mission);
								let contract_id = null;
								let society_id = null;
								if (this.$props.contract instanceof Array) {
									contract_id = this.$props.contract[0].id;
									society_id = this.$props.contract[0].society_id;
								} else {
									society_id = this.$props.contract.society_id;
									contract_id = this.$props.contract.id;
								}
								if (this.$props.editMode) {
									await this.mission.updateUserRelation(
										society_id,
										contract_id,
										this.$props.missionToModify.id,
										this.missionOld.account_managers,
										this.activeUser.id
									);
									// this.modifyTask(this.mission.id);
								} else {
									await this.mission.updateUserRelation(
										society_id,
										contract_id,
										res.data.id,
										this.missionOld.account_managers,
										this.activeUser.id
									);
									if (
										this.$props.contract.status &&
										this.$props.contract.status != 2
									) {
										if (
											this.mission.status == 1 &&
											!this.mission.products_id == 136
										) {
											await this.createTask(res.data.id);
										}
									}
								}
								this.$vs.notify({
									title: "Succès",
									text: notificationText,
								});
								if (this.$props.editContract == true) {
									let foundMission = this.productOptions.find(
										(product) => product.id == this.mission.products_id
									);
									let missionName =
										this.missionCategories[foundMission.category - 1] +
										" - " +
										foundMission.perform;
									if (this.mission.status != 4 && this.$props.editMode == false)
										this.sendMissionMailNotification(
											contract_id,
											missionName,
											society_id,
											this.activeUser.firstname + " " + this.activeUser.lastname
										);
								}
								// this.isLoad = false;
								this.setLoading(false, "mission-save-button-1");
								store.dispatch("getAllNotifications");
								this.$emit("close-form-after-added", 1);
								this.showPopup = false;
							})
							.catch((err) => {
								// this.isLoad = false;
								this.setLoading(false, "mission-save-button-1");
								let notificationText = this.$props.editMode
									? "La mission n'a pas été modifiée."
									: "La mission n'a pas été ajoutée.";
								this.$vs.notify({
									title: "Echec",
									text: notificationText,
								});
							});
						// })
						// .catch((error) => {
						// 	console.error(error);
						// 	//console.log("Got you.");
						// });
						// Send a success notification to the user

						/*
						 * Reset the mission (to get a new one)
						 * this.mission = new Mission();
						 * this.contractUser = new ContractUser();
						 * this.deliveryId = null;
						 * })
						 */
					}
				}
			} catch (e) {
				this.setLoading(false, "mission-save-button-1");
				console.log("formSubmitted Error", e);
				let notificationText = this.$props.editMode
					? "La mission n'a pas été modifiée."
					: "La mission n'a pas été ajoutée.";
				this.$vs.notify({
					title: "Echec",
					text: notificationText,
				});
			}
			//   this.$vs.loading.close("#addButton > .con-vs-loading");
		},

		createNewProduct() {
			this.checkProduct = true;
			let fields = ["perform", "longDescription", "shortDescription"];
			for (let i = 0; i < 3; i++) {
				if (this.product[fields[i]] == "" || this.product[fields[i]] == null) {
					this.validators[fields[i]].errText = "Ce champ ne peut être vide.";
					this.checkProduct = false;
				} else {
					this.validators[fields[i]].errText = "";
				}
			}
			this.$forceUpdate();

			if (this.checkProduct == false) {
				this.$vs.notify({
					title: "Echec",
					text: "Veuillez remplir tous les champs.",
				});
				return false;
			}
			this.$http
				.post(this.apiUrl + "product/new", {
					category: this.product.category + 1,
					perform: this.product.perform,
					short_description: this.product.shortDescription,
					long_description: this.product.longDescription,
					is_netlink: this.product.isNetlink,
				})
				.then((res) => {
					//console.log(res);
					// Send a success notification to the user
					this.$vs.notify({
						title: "Succès",
						text: "Prestation ajoutée avec succès.",
					});
					this.getAllProductForCategory();
					this.isPopupActive = false;
				})
				.catch((err) => {
					//console.log(err);
					this.$vs.notify({
						title: "Echec",
						text: "La prestation n'a pas été ajoutée.",
					});
				});
		},

		/**
		 * Closes the form
		 */
		closeForm() {
			//console.log("closeForm");
			this.$emit("close-form", false);
			this.showPopup = false;
		},

		createNewProductPopup() {
			//console.log("createNewProduct");
			this.isPopupActive = true;
		},

		createTask(missionId) {
			return new Promise((resolve, reject) => {
				try {
					let today = new Date(Date.now());
					let formatedStartDate =
						this.missionStartDate && this.missionStartDate.length >= 10
							? this.missionStartDate.substring(0, 10)
							: today.toISOString().substring(0, 10);
					formatedStartDate = formatedStartDate.split("/").reverse().join("-");
					formatedStartDate = formatedStartDate + " 02:00:00";
					let params = {
						mission_id: missionId,
						link: null,
						commentary: null,
						recurrence: this.mission.recurrence,
						frequency: this.mission.frequency,
						creation_date: formatedStartDate,
						finished_date: null,
						status: 0,
						archivate: 0,
						contract_id: this.$props.contract.id
							? [this.$props.contract.id]
							: this.$props.contract[0].id,
						contract_society_id: this.$props.contract.society_id
							? this.$props.contract.society_id
							: this.$props.contract[0].society_id,
					};

					//console.log(missionId);
					this.$http
						.post(this.apiUrl + "task/add", params)
						.then(() => {
							let notificationText = "Tâche ajoutée avec succès.";
							this.$vs.notify({
								title: "Succès",
								text: notificationText,
							});
							resolve(true);
						})
						.catch((err) => {
							//console.log("err", err);
							let notificationText = "La tâche n'a pas été ajoutée.";
							this.$vs.notify({
								title: "Echec",
								text: notificationText,
							});
							reject(err);
						});
				} catch (e) {
					reject(e);
				}
			});
		},

		findLastMissionTask(missionId) {
			this.$http
				.get(this.apiUrl + "task/getLast/" + missionId.toString())
				.then((res) => {
					return res.data[0];
				})
				.catch((err) => {
					//console.log("err", err);
					return null;
				});
		},
		async fetchCurrencies() {
			Product.getCurrencies()
				.then((res) => {
					this.currencies = res;
				})
				.catch((err) => {
					//console.log("err", err);
				});
		},

		modifyTask(missionId) {
			// let lastTask = this.findLastMissionTask(missionId)
			let lastTask;
			/*
			 * let today = new Date(Date.now())
			 * let formatedDate = today.toISOString()
			 * let re = new RegExp('([T|Z])', 'g')
			 * formatedDate = formatedDate.replace(re, " ")
			 */

			// //console.log(missionId)

			this.$http
				.get(this.apiUrl + "task/getLast/" + missionId.toString())
				.then((res) => {
					let formatedStartDate = null;
					if (this.missionStartDate && this.missionStartDate.length >= 10) {
						formatedStartDate = this.missionStartDate.substring(0, 10);
						formatedStartDate = formatedStartDate
							.split("/")
							.reverse()
							.join("-");
						formatedStartDate = formatedStartDate + " 02:00:00";
					}
					lastTask = res.data[0];
					//console.log("this.mission.status", this.mission.status);
					let archivateValue =
						this.mission.status == 5 ? 2 : this.mission.status == 4 ? 1 : 0;
					let statusValue = this.mission.status == 3 ? 2 : 1;
					let params = {
						mission_id: missionId,
						link: lastTask && lastTask.link ? lastTask.link : null,
						commentary:
							lastTask && lastTask.comentary ? lastTask.comentary : null,
						recurrence: this.mission.recurrence,
						frequency: this.mission.frequency,
						creation_date: formatedStartDate,
						finished_date: null,
						status: statusValue,
						archivate: archivateValue,
						contract_id: this.$props.contract.id
							? [this.$props.contract.id]
							: this.$props.contract[0].id,
						contract_society_id: this.$props.contract.society_id
							? this.$props.contract.society_id
							: this.$props.contract[0].society_id,
					};
					//console.log("lastTask", lastTask);
					if (lastTask) {
						this.$http
							.post(this.apiUrl + "task/edit/" + lastTask.id, params)
							.then(() => {
								let notificationText = "Tâche modifiée avec succès.";
								this.$vs.notify({
									title: "Succès",
									text: notificationText,
								});
							})
							.catch((err) => {
								//console.log("err", err);
								let notificationText = "La tâche n'a pas été modifiée.";
								this.$vs.notify({
									title: "Echec",
									text: notificationText,
								});
							});
					}
				})
				.catch((err) => {
					//console.log("err", err);
				});
		},
	},
};
</script>
  
  <style>
.container {
	display: flex;
	justify-content: center;
	align-items: center; /* You can adjust the height as needed */
}

.flex-container {
	display: flex;
	align-items: flex-end; /* Align items to the bottom */
}

.bottom-align {
	margin-bottom: 0; /* Reset any default margins if necessary */
}

.role_selector_container {
	justify-content: space-between;
	width: 40%;
}

.role_container {
	justify-content: center;
}

.space_div {
	margin: 5px;
}

.bottom {
	align-self: flex-end;
}

.center {
	align-self: center;
}

.inlineB {
	width: calc(100% - 30px) !important;
}

#select-control-width > .input-select-con {
	width: 100% !important;
}
</style>
  